import { useEffect, useContext } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { actionTypes as lactionTypes } from "../store/storeTypes";

const options = [
  { display: "PX", value: "px" },
  { display: "VS", value: "vecDates" },
  // { display: "VecEvents", value: "vecEvents" },
];

// const options = ["px", "vecDates", "vecEvents", "vecLevel", "vectorSet"];

const style = { fontSize: 14, fontWeight: 400 };
export const TableControl = () => {
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);
  const { tableViewSelectedKey } = lstore;

  useEffect(() => {
    //set default
    const option = options[0].value;
    ldispatch({
      type: lactionTypes.SET_TABLE_VIEW_SELECTED_KEY,
      payload: option,
    });
  }, [ldispatch]);

  const changefilter = (val) => {
    ldispatch({ type: lactionTypes.SET_TABLE_VIEW_SELECTED_KEY, payload: val });
  };

  return (
    <div
      style={{
        height: refs.componentSize.current["TableControl"].height,
        width: refs.componentSize.current["TableControl"].width,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display:
            refs.componentSize.current["TableControl"].height >
            refs.componentSize.current["TableControl"].width
              ? "block"
              : "flex",
          justifyContent: "center",
        }}
      >
        {options.map((item, i) => {
          return (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <input
                checked={tableViewSelectedKey === item.value}
                type="radio"
                value={item.value}
                name={"control"}
                onChange={() => changefilter(item.value, i)}
              />
              <span title={item.display} style={style}>
                {item.display}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
